import { Fragment } from "react"
import { BASE_IMG_PATH, trayVariants } from "./helpers"
import StyledFigure from "./components/StyledFigure"
import { Link } from "react-router-dom"

const TrayVariants = () => {
  return (
    <Fragment>
      <h1 className="text-center">
        <strong>Pick a Tray and start customizing</strong>
      </h1>
      <div className="row">
        {trayVariants.map(v => (
          <StyledFigure key={v.variant} className="col-sm-12 col-md-6">
            <Link
              to={{
                pathname: "/customization",
                search: `?trayVariant=${v.variant}`,
              }}
            >
              <img
                loading="lazy"
                className="img-responsive col-sm-7"
                src={BASE_IMG_PATH.concat(v.src)}
                alt={v.alt}
              />
            </Link>
            <figcaption>
              <strong>{v.variant}</strong>
            </figcaption>
          </StyledFigure>
        ))}
      </div>
    </Fragment>
  )
}

TrayVariants.propTypes = {}
export default TrayVariants
